import { reactive } from 'vue'

const store = reactive({
  functions: [],
  pages: [],
  cache: new Map()
})

export default store;